<template>
    <div class="fu-note" :class="{ 'fu-note--dirty': dirty }">
        <textarea
            v-model="draft"
            class="fu-note__input"
            :placeholder="__('note…')"
            rows="3"
            :disabled="saving"
            @blur="onBlur"
        ></textarea>

        <div class="fu-note__footer">
            <span v-if="saving" class="fu-note__hint">{{ __('Saving…') }}</span>

            <button v-else-if="dirty" type="button" class="fu-note__save" @click="save">
                {{ __('save note') }}
            </button>

            <span v-else-if="updatedAt" class="fu-note__hint" :title="formatDateTime(updatedAt)">
                {{ __('Saved') }} {{ fromNow(updatedAt) }}
            </span>
        </div>
    </div>
</template>

<script>
import followUpMixin from './followUpMixin'

export default {
    mixins: [followUpMixin],
    props: {
        caseId: {
            type: Number,
            required: true
        },
        note: {
            type: String,
            default: null
        },
        updatedAt: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            draft: this.note || '',
            saving: false
        }
    },
    computed: {
        dirty() {
            return (this.draft || '').trim() !== (this.note || '').trim()
        }
    },
    watch: {
        note(value) {
            // keep the editor in sync with the server unless the admin is in the middle of typing
            if (!this.dirty || !this.draft) {
                this.draft = value || ''
            }
        }
    },
    methods: {
        onBlur() {
            if (this.dirty) {
                this.save()
            }
        },
        save() {
            if (!this.dirty || this.saving) {
                return
            }

            this.saving = true

            // the page saves the note and calls done() when the request finished (success or failure)
            this.$emit('save', {
                caseId: this.caseId,
                note: this.draft.trim(),
                done: () => {
                    this.saving = false
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
.fu-note {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &__input {
        width: 100%;
        min-height: 72px;
        padding: 8px 10px;
        border: 1px solid #e4e2ee;
        border-radius: 8px;
        background: #fbfbfc;
        color: #2c2857;
        font-family: inherit;
        font-size: 13px;
        line-height: 1.4;
        resize: vertical;
        transition: border-color 0.15s ease;

        &:focus {
            outline: none;
            border-color: #5937b7;
            background: #fff;
        }

        &:disabled {
            opacity: 0.6;
        }
    }

    &--dirty &__input {
        border-color: #fdbd05;
    }

    &__footer {
        min-height: 18px;
        display: flex;
        justify-content: flex-end;
    }

    &__hint {
        color: #b3b1c2;
        font-size: 11px;
    }

    &__save {
        padding: 2px 10px;
        border: 0;
        border-radius: 10px;
        background: #5937b7;
        color: #fff;
        font-family: inherit;
        font-size: 11px;
        font-weight: 700;
        cursor: pointer;
    }
}
</style>
